import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Products from "@pages/Products";
import ProductComponent from "@components/ProductComponent";
import Contact from "@pages/Contact";
import ErrorPage from "@pages/Error";
import Services from "@pages/Services";
import Home from "@pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GlobalStyle } from "./GlobalStyle";
import { ThemeProvider } from "styled-components";
import CookieConsent from '@components/cookieconsent/CookieConsent';
import Privacy from "@pages/Privacy/Privacy";
import Downloads from "@pages/Downloads/Downloads";


function App() {
  const theme = {
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgba(29 ,29, 29, .8)",
      white: "#fff",
      black: " #212529",
      helper: "#8490ff",

      bg: "#F6F8FA",
      footer_bg: "#0a1435",
      btn: "rgb(98 84 243)",
      border: "rgba(98, 84, 243, 0.5)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: {
      mobile: "768px",
      tab: "998px",
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter >
        <Navbar />
        

        {/* <GlobalStyle /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="utrustning" element={<Products />} /> */}
           <Route path="/utrustning/*" element={<Products />} />
          <Route path="KONTAKTA-OSS" element={<Contact />} />
          <Route path="referenser" element={<Services />} />
          <Route path="/integritetspolicy" element={<Privacy />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="*" element={<ErrorPage />} />
          {/* <Route path="utrustning/:slug" element={<MainCategory />} />
          <Route path="utrustning/:cat/:subcat" element={<SubCategory />} />
          <Route path="utrustning/:cat/:subcat/:product" element={<ProductComponent />} /> */}

        </Routes>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </ThemeProvider>
    
  );
}

export default App;
